const TransparentButton = (props) => {
    const { children, size, kind,customClass, ...otherProps } = props;

    let className = "relative whitespace-nowrap hover:cursor-pointer inline-block bg-transparent border px-2 md:px-6 outline-none text-base rounded-xl md:rounded-2xl transition duration-200";
    className += size === "sm" ? " h-8" : size === "lg" ? " h-10" : " h-12";

    if (kind === 'danger')
        className += " border-red-200 hover:border-red-300 hover:text-red-500 text-red-600 dark:border-red-300 dark:hover:border-red-500 dark:text-red-400 dark:hover:text-red-500";
    else
        className += " border-gray-200 hover:border-gray-300 hover:text-gray-700 text-gray-800 dark:border-gray-700 dark:hover:border-gray-600 dark:hover:text-white dark:text-gray-100";
  
    return (
        // <button {...otherProps} className={className}>
        //     {children}
        // </button>
        <button {...otherProps} className={`${className} ${customClass}`}>
      {children}
    </button>
    );
};
  
export default TransparentButton;
  
  